import React from "react";
import classNames from "classnames";
import styles from "./LoginFormWrapper.module.css";
import { useTranslation } from "react-i18next";

export const LoginFormWrapper = ({ children, authType, setAuthType }) => {
  const { t, i18n } = useTranslation();

  if (authType == "RECOVER") return null;
  const text = authType == "PASSWORD" ? t("login.entry") : t("login.titleEDS");
  const passwordClassName = classNames(
    styles.passwordSelector,
    authType == "PASSWORD" ? styles.active1 : styles.notActive1
  );
  const signClassName = classNames(
    styles.passwordSelector,
    authType == "PASSWORD" ? styles.notActive2 : styles.active2
  );
  return (
    <div className={styles.LoginFormWrapper}>
      <div className={styles.selectorWrapper}>
        <div
          onClick={() => setAuthType("PASSWORD")}
          className={passwordClassName}
        >
          {t("login.byEmail")}
        </div>
        <div onClick={() => setAuthType("SIGN")} className={signClassName}>
          {t("login.byEDS")}
        </div>
      </div>

      <div className={styles.formWrapper}>
        <h1 className={styles.text}>{text}</h1>

        <div className={styles.LoginWrapper}>
          {authType == "PASSWORD" ? children[0] : children[1]}
        </div>
      </div>
    </div>
  );
};
